<template>
        <v-date-input
            :data-cy="`${dataCyPrefix}-date`"
            ref="dateField"
            :model-value="dateForInput"
            :label="$t('formFields.date')"
            variant="outlined"
            :multiple="single ? false : 'range'"
            prepend-icon=""
            hide-details="auto"
            :min="min"
            :max="max"
            :disabled="disabled"
            @update:modelValue="onDateInput"
            :rules="[requiredRule]"
        ></v-date-input>
</template>

<script>
import { formatToYmd } from "@/utils";

export default {
    props: {
        modelValue: Object,
        dataCyPrefix: String,
        min: { type: String, default: null },
        max: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        single: { type: Boolean, default: false },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            requiredRule: (value) => !!value || this.$t("validation.required"),
        };
    },
    computed: {
        dateForInput() {
            const dateArray = this.modelValue.date;
            if (this.single) {
                return dateArray?.length > 0 ? dateArray[0] : null;
            }
            return dateArray;
        },
    },
    methods: {
        onDateInput(value) {
            const dateArray = this.single && value != null ? [value] : value;
            this.updateDetails("date", dateArray);
        },
        async validateFields() {
            await this.$nextTick();

            const dateArray = this.modelValue.date;
            return !!(dateArray && dateArray.length > 0);
        },
        resetValidation() {
            this.$nextTick(() => {
                if (this.$refs.dateField?.resetValidation) {
                    this.$refs.dateField.resetValidation();
                }
            });
        },
        updateDetails(field, value) {
            if (field === "date") {
                const dateArray = value && value.length > 0 ? value : [];
                if (dateArray.length > 0) {
                    const startDate = dateArray[0];
                    const endDate = this.single ? startDate : dateArray[dateArray.length - 1];
                    const normalizedDateArray = this.single ? [startDate] : dateArray;

                    this.$emit("update:modelValue", {
                        ...this.modelValue,
                        dateStart: formatToYmd(startDate) ?? "",
                        dateEnd: formatToYmd(endDate) ?? "",
                        date: normalizedDateArray,
                    });
                } else {
                    this.$emit("update:modelValue", {
                        ...this.modelValue,
                        dateStart: "",
                        dateEnd: "",
                        date: [],
                    });
                }
            } else {
                this.$emit("update:modelValue", {
                    ...this.modelValue,
                    [field]: value,
                });
            }
        },
    },
};
</script>
